<mat-toolbar>
  <button mat-icon-button (click)="sidenav.toggle()"
    [attr.aria-label]="'mainLayout.sidenavToggleAriaLabel' | translate">
    <mat-icon>menu</mat-icon>
  </button>
  <span class="customer-name">{{ customerName() }}</span>
  <div class="actions">
    <button mat-icon-button (click)="openAppSettingsDialog()"
      [attr.aria-label]="'appSettings' | translate"
      [matTooltip]="'appSettings' | translate">
      <mat-icon>settings</mat-icon>
    </button>
    <sp-feedback-button />
    <sp-user-button />
  </div>
</mat-toolbar>

<mat-sidenav-container>
  <mat-sidenav #sidenav opened [mode]="shouldOverlay() ? 'over' : 'side'" [class.docked]="!shouldOverlay()">
    <sp-store-selection />
    <mat-nav-list>
      @for (section of navSections; track section) {

      @if(section.nameKey) {
      <span class="section-header">{{ section.nameKey | translate }}</span>
      }

      @for (item of section.items; track $index) {
      @if (item.route && (!item.visible || item.visible())) {
      <a mat-list-item [routerLink]="item.route" routerLinkActive="active-list-item">
        <mat-icon matListItemIcon [matBadge]="item.count?.()" aria-hidden="false" [attr.aria-label]="item.nameKey | translate">{{ item.icon }}</mat-icon>
        <span class="label-text">{{ item.nameKey | translate }}</span>

      </a>
      }

      }
      }
    </mat-nav-list>
    <footer sp-footer></footer>
  </mat-sidenav>

  <mat-sidenav-content [class.wrapped]="!shouldOverlay()">
    <router-outlet />
  </mat-sidenav-content>
</mat-sidenav-container>